import { regEmail } from '@constants';

export function isUserMobile() {
  const ua = navigator?.userAgent?.toLowerCase();
  return /mobile|android|iphone|ipod|phone|ipad/i.test(ua);
}
export function isEmail(email) {
  return regEmail.test(email);
}

export const isOnlyNumber = (number) => {
  const reg = /^\d*$/;
  return reg.test(number);
};

// 验证value是否为长度5-30，除了字母数字和下划线”_“，横杠”-”之外，其他特殊字符不可以
export const isValiate = (value) => {
  if (/^[a-zA-Z][a-zA-Z0-9-_]{4,29}$/.test(value)) {
    return true;
  }
  return false;
};
